<template>
  <div>
    <v-flex v-if="simc && showSelect" xs12 pr-2>
      <v-autocomplete
        v-model="model[field].$value"
        clearable
        hide-no-data
        placeholder="Wpisz nazwę ulicy"
        item-text="nameFull"
        item-value="symbol"
        :items="streets"
        :search-input.sync="search"
        :error-messages="model.street.$error"
        @focus="focus('street')"
        @blur="blur('street')"
        @change="changeStreet"
      >
        <div slot="label">
          {{ fieldModel.$schema.title }}
          <span v-if="fieldModel.$schema.fieldRequired">*</span>
        </div>
      </v-autocomplete>
    </v-flex>
  </div>
</template>

<script>
import { notificationsMixin } from '@/mixins/notifications';
import { checkIfStreetsExist, searchStreets, getStreetNameBySymbol } from '@/utils/ulicHelper';

// @vuese
// Input na ULIC-a
// @group Components/Forms
export default {
  mixins: [notificationsMixin],
  props: {
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Nazwa pola z ULIC-em
    field: {
      type: String,
      required: false,
      default: 'ulic'
    },
    // Czy ulica jest wymagana
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    },
    // Wartość SIMC-a
    simc: {
      type: String,
      required: true
    },
    // Nazwa miasta
    city: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      streets: [],
      search: '',
      showSelect: false
    };
  },
  computed: {
    fieldModel() {
      return this.model[this.field];
    }
  },
  watch: {
    simc(newValue) {
      this.streets = [];
      this.model.$setData({
        street: '',
        [this.field]: ''
      });
      this.checkULICList();
    },
    search(val) {
      if (val) {
        this.searchULICList(val);
      }
    }
  },
  beforeMount() {
    this.checkULICList();
    this.setULICData();
  },
  methods: {
    // @vuese
    // Sprawdza czy lista ulic nie jest pusta
    async checkULICList() {
      if (this.terc && this.simc) {
        try {
          const hasStreets = await checkIfStreetsExist(this.terc, this.simc);

          if (!hasStreets) {
            this.model.$setData({
              street: this.city
            });
            this.showSelect = false;
            if (this.required) {
              this.model.street.$schema.fieldRequired = false;
              this.model[this.field].$schema.fieldRequired = false;
              this.label = 'Ulica';
            }
          } else {
            this.showSelect = true;
            if (this.required) {
              this.model.street.$schema.fieldRequired = true;
              this.model[this.field].$schema.fieldRequired = true;
              this.label = 'Ulica *';
            }
          }
        } catch (error) {
          this.notifyError('Nie udało się pobrać listy ulic');
        }
      }
    },
    // @vuese
    // Przeszukuje listę ulic
    async searchULICList(val) {
      if (this.terc && this.simc) {
        try {
          this.streets = await searchStreets(this.terc, this.simc, val);
        } catch (error) {
          this.notifyError('Nie udało się pobrać listy ulic');
        }
      }
    },
    // @vuese
    // Ustawianie pól formularza
    setULICData() {
      if (this.model.street) {
        this.search = this.model.street.$value;
      } else if (this.model[this.field].$value) {
        this.findStreetName();
      }
    },
    // @vuese
    // Pobiera nazwę ulicy na podstawie symbolu ulicy
    async findStreetName() {
      try {
        const streetName = await getStreetNameBySymbol(this.simc, this.model[this.field].$value);
        if (streetName) {
          this.search = streetName;
        }
      } catch (error) {
        this.notifyError('Nie udało się pobrać listy ulic');
      }
    },
    // @vuese
    // Zapisanie w schema odpowiednich pól po wybraniu ulicy
    changeStreet(val) {
      this.model.$setData({
        street: val ? this.streets.find(item => item.symbol === val).nameFull : '',
        [this.field]: val ? val : ''
      });
    },
    focus(field) {
      this.model[field].$hasFocus = true;
    },
    blur(field) {
      this.model[field].$hasFocus = false;
    }
  }
};
</script>
